// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/panel-right-open.js';

import { paths } from '../generated/panel-right-open';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('panel-right-open', Original, paths);
